export default __webpack_public_path__ + "static/media/blade-drag.e785c467.png";